import '@mdi/font/css/materialdesignicons.min.css'
import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

const opts = {
    icons: {
        iconfont: 'mdi', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
    },
    theme: {
        themes: {
            light: {
                anchor: '#000', // Change the default link color to black
                primary: '#67CEA3', // Change the default primary color to aquamarine
                secondary: colors.grey.darken1,
                accent: colors.shades.black,
                alternate: '#F2F2F2',
                PASS: '#49C533',
                FAIL: '#E23C30',
                NA: '#FFC107',
            },
        },
    },
}

export default new Vuetify(opts);
